import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Work_Sans\",\"arguments\":[{\"variable\":\"--font-work-sans\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"600\",\"700\",\"800\"],\"display\":\"swap\"}],\"variableName\":\"workSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/ClientBody.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/components/ScrollToTop.tsx");
